import React, { PropTypes, Component } from 'react'
import co from 'co'
import DataTable from 'components/dataTable'
import NewDataForm from './newDataForm'
import misc from 'utils/misc'
import styles from './styles.scss'

export default class DataSyncTable extends Component {

  static propTypes = {
    dataUtil: PropTypes.object.isRequired,
    schemas: PropTypes.array.isRequired,
    radioSelectKey: PropTypes.string,
    pollInterval: PropTypes.number,
  };

  static defaultProps = {
    pollInterval: 5000,
  };

  constructor (props, context) {
    super(props, context)
    this.onDataUpdate = ::this.onDataUpdate
    this.loadDataArrayFromServer = ::this.loadDataArrayFromServer
    this.onExport = ::this.onExport
  }

  state = {
    dataArray: [],
  };

  componentWillMount () {
    this.loadDataArrayFromServer()
    const intervalId = setInterval(this.loadDataArrayFromServer, this.props.pollInterval)
    this.setState({ intervalId })
  }

  componentWillUnmount () {
    clearInterval(this.state.intervalId)
  }

  onDataUpdate (newData) {
    // client side
    const dataArray = this.state.dataArray.map(data => (data._id === newData._id ? newData : data))
    this.setState({ dataArray })

    // update records at the server
    const { dataUtil } = this.props
    co(function*() {
      yield dataUtil.update(newData)
    }).catch(misc.onError)
  }

  onExport () {
    let csv = '\uFEFF'
    const schemas = this.props.schemas
    const colNum = schemas.length
    schemas.forEach((s, i) => {
      csv += s.title
      if (i !== colNum - 1) {
        csv += ','
      } else {
        csv += '\n'
      }
    })
    this.state.dataArray.forEach(data => {
      schemas.forEach((s, i) => {
        if (!s.map) {
          csv += data[s.key]
        } else {
          csv += s.map[data[s.key]]
        }
        if (i !== colNum - 1) {
          csv += ','
        } else {
          csv += '\n'
        }
      })
    })

    misc.saveCSV('未命名.csv', csv)
  }

  loadDataArrayFromServer () {
    const _this = this
    co(function *() {
      const dataArray = yield _this.props.dataUtil.find()
      _this.setState({ dataArray })
    }).catch(misc.onError)
  }

  render () {
    const { schemas, radioSelectKey } = this.props

    return (
      <div>
        <div className={styles.sideForm}>
          <NewDataForm
            schemas={schemas}
            dataUtil={this.props.dataUtil}
            loadDataArrayFromServer={this.loadDataArrayFromServer}
          />
          <div className={styles.submit}>
            <input type="submit" value="下載CSV" onClick={this.onExport} />
          </div>
        </div>
        <DataTable
          schemas={schemas}
          radioSelectKey={radioSelectKey}
          dataArray={this.state.dataArray}
          onDataUpdate={this.onDataUpdate}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataSyncTable/index.jsx